import React from 'react';
import { FormMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useSourceFilter } from './useSourceFilter';

export const SourceFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, sourceOptions } = useSourceFilter({
    setFilters,
  });

  // Transform incoming value to match the serialized format
  const initialValues = {
    sources: (value || []).map((source) => ({
      label: source.label,
      value: JSON.stringify(source.value), // Serialize array to string
    })),
  };

  return (
    <Formik initialValues={initialValues} validationSchema={formSchema} onSubmit={onSubmit} enableReinitialize>
      <Form>
        <FormikAutoSubmit />
        <Field
          name="sources"
          label="Source"
          placeholder="Add..."
          size="small"
          component={FormMultiSelect}
          options={sourceOptions}
          anchorToBody
          isSearchable={false}
        />
      </Form>
    </Formik>
  );
};

SourceFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

SourceFilter.defaultProps = {
  value: [],
};
